/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-return-await */
/* eslint-disable vars-on-top */
/* eslint-disable no-var */
/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { message } from 'antd';
import { createRoot } from 'react-dom/client';
import _ from 'lodash';
import axios from 'axios';
import XLSX from 'xlsx';
import * as moment from 'moment';
import $ from 'jquery';
import logger from './logger';
import { getSession } from './storage-service';
// eslint-disable-next-line import/no-cycle
import { getLoginBusinessId, getLoginRes } from './auth-details-service';
// eslint-disable-next-line import/no-cycle
import { showWarningMessageAlert, showInfoMessageAlert, showMessageAlert, getMediaImgSrc } from '../utilities/utility';
import { templates, googleMapBaseUrl } from '../constants';
import { Button } from '../components/cp-buttons/cp-buttons';
import { getLookupData, getRefChildsDetailsLookupByField, getTableRowsList, getTxnList } from '../actions/api-actions';
import useBizAccountObjPermissions from '../components/cp-biz-account-permission';
// eslint-disable-next-line import/no-named-as-default
import ApiService from '../config/api/api-service';
import { ApiLibrary } from '../config/api/api-library';
import { getGoogleAPIKey } from '../config/env-config';
import HooperLoadingWithText from '../components/cp-spinners/cp-spinner-with-text';

const ScriptLogicWrapperService = () => {
  const businessId = getLoginBusinessId();
  const bizAccountObjPermissions = useBizAccountObjPermissions(businessId);

  const [service, setService] = useState(null);
  const [fields, setFields] = useState(null);
  const [transaction, setTransaction] = useState(null);
  const [perspectiveId, setPerspectiveId] = useState(null);
  const [callFunFromScriptWrapper, setCallFunFromScriptWrapper] = useState(null);
  const [getCommentAndAttachmentsCount, setGetCommentAndAttachmentsCount] = useState(null);
  const [subFormDocId, setSubFormDocId] = useState(null);
  const [setLookupFun, setSetLookupFun] = useState(null);
  const [refreshFieldFun, setRefreshFieldFun] = useState(null);
  const [hideTableActionsFun, setHideTableActionsFunState] = useState(null);
  let attachmentCommentsData = {};
  // const [verifySubformChecksObj, setVerifySubformChecksObj] = useState({});

  // this functionality for only checking comments and attachments counts.
  const updateAttachmentCommentsFields = async (data) => {
    if (data) {
      attachmentCommentsData = data;
    }
  };

  const setServiceRelatedInfo = (service, fields, txn, perspectiveId, callFunFromScriptWrapper) => {
    setService(service);
    setFields(fields);
    setTransaction(txn);
    setPerspectiveId(perspectiveId);
    setCallFunFromScriptWrapper(callFunFromScriptWrapper);
    // setVerifySubformChecksObj(verifySubformChecksObj);
  };

  // script logic for moment.
  if (typeof window !== 'undefined') {
    window.moment = (date = '') => {
      if (date) {
        return moment(date);
      } if (date === null || date === undefined) {
        // If null or undefined is passed inside brackets from script logic, it should return null
        return null;
      }
      return moment();
    };
  }

  const setTableCallFunFromScriptWrapper = (callFunFromScriptWrapper) => {
    if (callFunFromScriptWrapper) {
      setCallFunFromScriptWrapper(callFunFromScriptWrapper);
    }
  };

  const getServiceInfo = () => {
    return service;
  };

  const getTxnInfo = () => {
    return transaction;
  };

  const setCommentsAndAttachmentsFun = (newGetCommentAndAttachmentsCount) => {
    if (newGetCommentAndAttachmentsCount) {
      setGetCommentAndAttachmentsCount(newGetCommentAndAttachmentsCount);
    }
  };

  const subFormFuns = (newGetSubFormDocId) => {
    if (newGetSubFormDocId) {
      setSubFormDocId(newGetSubFormDocId);
    }
  };
  const setAdditionalFuns = (newSetLookupFun) => {
    if (newSetLookupFun) {
      setSetLookupFun(newSetLookupFun);
    }
  };
  const setRefreshFuns = (newRefreshFieldFun) => {
    setRefreshFieldFun(newRefreshFieldFun);
  };
  const setHideTableActionsFun = (newHideTableActionsFun) => {
    setHideTableActionsFunState(newHideTableActionsFun);
  };

  const tableRowsContain = (rows, fieldName, selectedValue) => {
    let matchCount = 0;

    if (rows && rows?.length > 1) {
      const { type } = rows[0].fields[fieldName];
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < rows.length; i++) {
        switch (type) {
          case templates.UI_TEMPLATES.LOOKUP_UI_TEMPLATE:
            logger.debug(typeof selectedValue);
            if (typeof selectedValue === 'object') {
              if (rows[i].fields[fieldName].value.id === selectedValue.id) {
                // eslint-disable-next-line no-plusplus
                matchCount++;
                logger.debug('matchCount', matchCount);
                if (matchCount > 1) break;
              }
            } else if (rows[i].fields[fieldName].value === selectedValue) {
              // eslint-disable-next-line no-plusplus
              matchCount++;
              logger.debug('matchCount', matchCount);
              if (matchCount > 1) break;
            }
            break;

          default:
            if (rows[i].fields[fieldName].value === selectedValue) {
              // eslint-disable-next-line no-plusplus
              matchCount++;
              logger.debug('matchCount', matchCount);
              if (matchCount > 1) break;
            }
        }
      }
    }

    return matchCount > 1;
  };

  // showing warning popup.
  const showWarn = (warnMsg) => {
    showWarningMessageAlert(warnMsg);
  };

  // showing info popup
  const showInfo = (infoMsg) => {
    showInfoMessageAlert(infoMsg);
  };

  const showActionableAlert = (header, infoMsg, buttonsObj, callback) => {
    const key = `custom_notification_${Date.now()}`;

    // Add the class to the body when modal is opened
    document.body.classList.add('modal-open'); 

    const handleButtonClick = (btnVal) => {
      message.destroy(key); // Close the message before executing the callback
      // Remove the class from the body when modal is closed
      document.body.classList.remove('modal-open');
      callback(btnVal);
    };
    const content = (
      <div className='action_alert_item' key={key}>
        <h3>{header}</h3>
        <p>{infoMsg}</p>
        <div style={{ padding: '20px', display: 'flex' }}>
          {Object.keys(buttonsObj).map((label, index) => (
            <div style={{ padding: '10px' }} key={label}>
              <Button
                key={index}
                type=""
                style={{ background: buttonsObj[label] }}
                onClick={() => handleButtonClick(label)}
              >
                {label}
              </Button>
            </div>
          ))}
        </div>
      </div>
    );
    message.info({ content, key, duration: 0 }); // Set duration to 0 for manual closing
  };

  // get txn id.
  const txnId = () => {
    const transaction = getTxnInfo();
    return transaction && transaction.id ? transaction.id : null;
  };

  const fetch = async (action, fieldName, callback) => {
    // eslint-disable-next-line default-case
    switch (action) {
      case 'childsOf':
        var childType = service ? service.type : '';
        var parentType = fields[fieldName] ? fields[fieldName].lookupType : '';
        var refField = fields[fieldName] ? fields[fieldName].refId : '';
        var txnId = fields[fieldName] ? fields[fieldName].selectedValue : '';

        try {
          const response = await getRefChildsDetailsLookupByField('0', '0', parentType, txnId, childType, refField);
          const res = response?.data;
          if (res.statusCode === 0) {
            if (res?.data) {
              if (callback) callback(res?.data?.content);
            }
          } else {
            showWarningMessageAlert(res?.statusMessage);
          }
          break;
        } catch (error) {
          // Handle any errors that occur during the process
        }
    }
  };

  const childsOf = async (fieldName, childType, callback) => {
    var parentType = fields[fieldName] ? fields[fieldName].lookupType : '';
    var refField = fields[fieldName] ? fields[fieldName].refId : '';
    var txnId = fields[fieldName] ? fields[fieldName].selectedValue : '';
    try {
      const response = await getRefChildsDetailsLookupByField('0', '0', parentType, txnId, childType, refField);
      const res = response?.data;
      if (res.statusCode === 0) {
        if (res?.data) {
          if (callback) callback(res?.data?.content);
        }
      } else {
        showWarningMessageAlert(res?.statusMessage);
      }
    } catch (error) {
      // Handle any errors that occur during the process
    }
  };

  const getRowsOf = async (txnId, refTableId, callback) => {
    try {
      // var getURL = $rootScope.HOOPER_BASE_URL + "table/row/list/" + txnId + "/" + refTableId;
      const loginUserData = getLoginRes();
      $.ajax({
        type: "GET",
        async: false,
        url: `${ApiService.baseURL}/${ApiLibrary?.V2?.TABLE_ROW_LIST}/${txnId}/${refTableId}`,
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${loginUserData?.access_token}`,
        },
        dataType: "json",
        success(response) {
          var res = response;
          if (res.statusCode === 0) {
            if (res.data) {
              if (callback) callback(res.data);
            } else if (callback) callback(null);
          } else {
            showWarningMessageAlert(res?.statusMessage);
          }
        }
      });
    } catch (error) {
      // Handle error here
      logger.error('An error occurred:', error);
    }
  };

  const rowsOf = async (txnId, refTableId, callback) => {
    try {
      const loginUserData = getLoginRes();
      $.ajax({
        type: "GET",
        async: false,
        url: `${ApiService.baseURL}/${ApiLibrary?.V2?.TABLE_ROW_LIST}/${txnId}/${refTableId}`,
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${loginUserData?.access_token}`,
        },
        dataType: "json",
        success(response) {
          var res = response;
          if (res.statusCode === 0) {
            if (res.data) {
              if (callback) callback(res.data);
            } else if (callback) callback(null);
          } else {
            showWarningMessageAlert(res?.statusMessage);
          }
        }
      });
    } catch (error) {
      // Handle error here
      logger.error('An error occurred:', error);
    }
  };

  // table related script logic functionality.
  // tableName, rows, action, isSink, rowFields, fieldConfigurations, txnData
  const addRows = (tableName, rows, isSink) => {
    if (callFunFromScriptWrapper) {
      callFunFromScriptWrapper(
        tableName,
        rows,
        'ADD_ROW',
        isSink,
        fields[tableName]?.tableRows,
        fields,
        transaction,
        service?.type,
        perspectiveId,
      );
    }
  };

  const updateRow = (tableName, rowIdx, fields) => {
    if (callFunFromScriptWrapper) {
      return callFunFromScriptWrapper(
        tableName,
        rowIdx - 1,
        'UPDATE_ROW',
        false,
        fields[tableName]?.tableRows,
        fields,
        transaction,
        service?.type,
        perspectiveId,
      );
    }
  };

  const removeRow = (tableName, rowIdx) => {
    if (callFunFromScriptWrapper) {
      return callFunFromScriptWrapper(
        tableName,
        rowIdx - 1,
        'REMOVE_ROW',
        false,
        fields[tableName]?.tableRows,
        fields,
        transaction,
        service?.type,
        perspectiveId,
      );
    }
  };

  const removeRows = (tableName, isSink) => {
    if (callFunFromScriptWrapper) {
      callFunFromScriptWrapper(
        tableName,
        {},
        'DELETE_ROWS',
        isSink,
        fields[tableName]?.tableRows,
        fields,
        transaction,
        service?.type,
        perspectiveId,
      );
    }
  };

  const replaceRows = (tableName, rows, isSink) => {
    if (callFunFromScriptWrapper) {
      callFunFromScriptWrapper(
        tableName,
        rows,
        'REPLACE_ROWS',
        isSink,
        fields[tableName]?.tableRows,
        fields,
        transaction,
        service?.type,
        perspectiveId,
      );
    }
  };

  const getRows = (tableName) => {
    return fields[tableName]?.tableRows;
    // if (callFunFromScriptWrapper) {
    //   return callFunFromScriptWrapper(
    //     tableName,
    //     null,
    //     'GET_ROWS',
    //     false,
    //     fields[tableName]?.tableRows,
    //     fields,
    //     transaction,
    //     service?.type,
    //     perspectiveId,
    //   );
    // }
  };

  const getRow = (tableName, rowIdx) => {
    return fields[tableName].tableRows[rowIdx - 1];
    // if (callFunFromScriptWrapper) {
    //   return callFunFromScriptWrapper(
    //     tableName,
    //     rowIdx - 1,
    //     'GET_ROW',
    //     false,
    //     fields[tableName]?.tableRows,
    //     fields,
    //     transaction,
    //     service?.type,
    //     perspectiveId,
    //   );
    // }
  };

  const updateColumn = (tableName, colomnObj) => {
    if (callFunFromScriptWrapper) {
      return callFunFromScriptWrapper(
        tableName,
        colomnObj,
        'UPDATE_COLUMN',
        false,
        fields[tableName]?.tableRows,
        fields,
        transaction,
        service?.type,
        perspectiveId,
      );
    }
  };

  const setRowsVisibile = (tableName, count) => {
    if (callFunFromScriptWrapper) {
      return callFunFromScriptWrapper(
        tableName,
        count,
        'ROWS_HEIGHT',
        false,
        fields[tableName]?.tableRows,
        fields,
        transaction,
        service?.type,
        perspectiveId,
      );
    }
  };

  const commentCount = (fieldName) => {
    let count = 0;
    let refId = null;
    const fieldsObj = attachmentCommentsData?.fields || fields;
    const txnData = attachmentCommentsData?.txnData || transaction;
    if (fieldName) {
      refId = fieldsObj[fieldName] ? fieldsObj[fieldName].refId : null;
      count = 0;
      if (txnData?.id) {
        if (txnData?.fieldsMeta) {
          const resultArray = txnData?.fieldsMeta?.filter(
            (item) => item?.type === `${fieldsObj[fieldName]?.refId}/COMMENT_STORE`,
          );
          count = resultArray.length;
        }
      }
      if (refId && fieldsObj[fieldName]?.commentsList !== undefined) {
        // eslint-disable-next-line no-unsafe-optional-chaining
        if (fieldsObj[fieldName]?.commentsList[refId]) {
          count = fieldsObj[fieldName]?.commentsList[refId]?.length;
        }
      }
    }
    // if (getCommentAndAttachmentsCount) {
    //   count = getCommentAndAttachmentsCount(fieldName, fieldsObj, txnData, 'GET_COMMENT_COUNT');
    // }
    return count;
  };

  const attachCount = (fieldName) => {
    let count = 0;
    const fieldsObj = attachmentCommentsData?.fields || fields;
    const txnData = attachmentCommentsData?.txnData || transaction;
    let refId = null;
    if (fieldName) {
      refId = fieldsObj[fieldName] ? fieldsObj[fieldName].refId : null;
      count = 0;
      if (txnData?.id) {
        if (txnData?.fieldsMeta) {
          const resultArray = txnData?.fieldsMeta?.filter(
            (item) => item?.type === `${fieldsObj[fieldName]?.refId}/ASSET`,
          );
          count = resultArray.length;
        }
      }
      if (refId && fieldsObj[fieldName]?.attachmentList !== undefined) {
        // eslint-disable-next-line no-unsafe-optional-chaining
        if (fieldsObj[fieldName]?.attachmentList[refId]) {
          count = fieldsObj[fieldName]?.attachmentList[refId]?.length;
        }
      }
    }
    // if (getCommentAndAttachmentsCount) {
    //   count = getCommentAndAttachmentsCount(fieldName, fieldsObj, txnData, 'GET_ATTACHMENT_COUNT');
    // }
    return count;
  };

  const currRefId = () => {
    var docId = subFormDocId;
    return docId || null;
  };

  function getPosition(position) {
    var lat = position.coords.latitude;
    var lon = position.coords.longitude;
    return `${lat},${lon}`;
  }

  const getLocation = (callback, coordinates) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          var pos = coordinates ? coordinates.toString() : getPosition(position);
          $.ajax({
            type: "GET",
            async: false,
            url: `${googleMapBaseUrl?.GOOGLE_MAPS_BASE_URL}?latlng=${pos}&key=${getGoogleAPIKey()}`,
            dataType: "json",
            success(response) {
              if (response?.status === 'OK') {
                var res = response?.results[0];
                logger.debug(res?.formatted_address);
                if (res.formatted_address) {
                  var objLocation = { location: res.formatted_address, coordinates: [], zipcode: 0 };
                  objLocation.coordinates.push(res.geometry.location.lat);
                  objLocation.coordinates.push(res.geometry.location.lng);
                  if (
                    res.address_components &&
                    res.address_components[res.address_components.length - 1] &&
                    res.address_components[res.address_components.length - 1].types[0] === 'postal_code'
                  ) {
                    objLocation.zipcode = parseInt(
                      res.address_components[res.address_components.length - 1].short_name ||
                      res.address_components[res.address_components.length - 1].long_name,
                    );
                  }
                  setTimeout(() => {
                    for (const key in fields) {
                      if (fields[key])
                        if (fields[key]?.type !== templates?.UI_TEMPLATES?.TABLE_UI_TEMPLATE && fields[key]?.type !== templates?.UI_TEMPLATES?.SUB_FORM_UI_TEMPLATE) {
                          if (window.updateStateFromUtility) window.updateStateFromUtility(fields[key], true);
                        }
                    }
                  }, 1000);
                  callback(objLocation);
                } else {
                  callback({});
                }
              } else {
                logger.error('Error fetching location data:');
              }
            }
          });
        },
        function () {},
        {
          enableHighAccuracy: true,
        },
      );
    } else {
      showMessageAlert('Location not supported');
    }
  };

  const mfFields = function () {
    return fields;
  };

  const getTxnUsingFields = async (fieldsJson, callback, dateCriteria, serviceType = service?.type, pageSize = 10) => {
    const reqJson = {
      serviceType: serviceType || service?.type,
      platformType: service?.platformType,
      fields: fieldsJson,
    };
    var perspectId = perspectiveId;

    if (serviceType) {
      if (serviceType.includes('USR_TYPE')) {
        reqJson.platformType = 'USR_INDIVIDUAL';
      } else {
        reqJson.platformType = 'SVC_FORM';
      }
      const isPerspectiveList = bizAccountObjPermissions?.objPermissions[serviceType];
      if (isPerspectiveList && Object.values(isPerspectiveList)[0]) {
        perspectId = Object.values(isPerspectiveList)[0].perspectiveId;
        setPerspectiveId(perspectId);
      }
    }

    if (dateCriteria) {
      reqJson.dateCriteria = dateCriteria;
    }
    try {
      const loginUserData = getLoginRes();
      $.ajax({
        type: "POST",
        async: false,
        url: `${ApiService.baseURL}/${ApiLibrary?.V2?.TXN_LIST}/${perspectId}/1/${pageSize}`,
        headers: {
          'Content-type': 'application/json',
          'Authorization': `Bearer ${loginUserData?.access_token}`,
        },
        data: JSON.stringify(reqJson),
        dataType: "json",
        success(response) {
          const res = response;
          if (res.statusCode === 0) {
            if (res.data && res.data.content) {
              if (res.data.content.length > 0) {
                if (res.data.content.length < res.data.totalRecords) {
                  // Recursive call with updated parameters
                  return getTxnUsingFields(fieldsJson, callback, dateCriteria, serviceType, res.data.totalRecords);
                }
                if (callback) {
                  if (res.data.content.length === 1) {
                    callback(res.data.content[0]);
                  } else {
                    callback(res.data.content);
                  }
                }
              } else if (callback) {
                callback(null);
              }
            } else if (callback) {
              callback(null);
            }
          } else {
            showWarningMessageAlert(res?.statusMessage);
            throw new Error(res?.statusMessage);
          }
        }
      });

    } catch (error) {
      logger.error('Error fetching data:', error);
      throw error;
    }
  };

  const getTxnUsingIncFields = async (fieldsJson, includes, callback, dateCriteria, serviceType, pageSize = 10) => {
    var reqJson = {
      serviceType: serviceType || service.type,
      platformType: service.platformType,
      fields: fieldsJson,
    };
    var perspectiveId = '*';
    if (dateCriteria) {
      reqJson.dateCriteria = dateCriteria;
    }
    if (Array.isArray(includes) && includes.length > 0) {
      reqJson.includes = includes || [];

      try {
        const loginUserData = getLoginRes();
        $.ajax({
          type: "POST",
          async: false,
          url: `${ApiService.baseURL}/${ApiLibrary?.V2?.TXN_LIST}/${perspectiveId}/1/${pageSize}`,
          headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${loginUserData?.access_token}`,
          },
          data: JSON.stringify(reqJson),
          dataType: "json",
          success(response) {
            const res = response;
            if (res.statusCode === 0) {
              if (res.data && res.data.content) {
                if (res.data.content.length > 0) {
                  if (res.data.content.length < res.data.totalRecords) {
                    // Recursive call with updated parameters
                    return getTxnUsingIncFields(fieldsJson, includes, callback, dateCriteria, serviceType, res.data.totalRecords);
                  }
                  if (callback) {
                    if (res.data.content.length === 1) {
                      callback(res.data.content[0]);
                    } else {
                      callback(res.data.content);
                    }
                  }
                } else if (callback) {
                  callback(null);
                }
              } else if (callback) {
                callback(null);
              }
            } else {
              showWarningMessageAlert(res?.statusMessage);
              throw new Error(res?.statusMessage);
            }
          }
        });

      } catch (error) {
        logger.error('Error fetching data:', error);
        throw error;
      }
    }
  };

  const childsOfUsingChildType = async (childType, callback) => {
    var parentType = service ? service?.type : '';
    var txnId = transaction ? transaction?.id : '';
    try {
      const response = await getRefChildsDetailsLookupByField('0', '0', parentType, txnId, childType);
      const res = response?.data;
      if (res.statusCode === 0) {
        if (res?.data) {
          if (callback) await callback(res?.data?.content);
        }
      } else {
        showWarningMessageAlert(res?.statusMessage);
      }
    } catch (error) {
      // Handle any errors that occur during the process
    }
  };

  const findLookupTxn = async (value, lookupType, callback) => {
    try {
      if (value !== null && value !== undefined) {
        const loginUserData = getLoginRes();
        $.ajax({
          type: "GET",
          async: false,
          url: `${ApiService.baseURL}/${ApiLibrary?.V2?.LOOKUP_API}/${lookupType}/${value}`,
          headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${loginUserData?.access_token}`,
          },
          dataType: "json",
          success(response) {
            const res = response;
            if (res.statusCode === 0) {
              if (res.data) {
                if (callback) callback(res?.data);
              } else if (callback) {
                callback(null);
              }
            } else {
              showWarningMessageAlert(res?.statusMessage);
              throw new Error(res?.statusMessage);
            }
          }
        });
      }
    } catch (error) {
      // Handle any errors that occur during the process
    }
  };

  const setLookupValue = function (value, lookupType, destinationObj) {
    if (setLookupFun) {
      if (destinationObj) {
        destinationObj.value = '';
      }
      setLookupFun(value, lookupType, destinationObj);
    }
  };

  const hideField = function (fieldNames) {
    if (fieldNames && Array.isArray(fieldNames)) {
      setTimeout(function () {
        fieldNames.forEach((field) => {
          const element = document.getElementById(field);
          if (element) {
            element.style.display = 'none';
          }
        });
      }, 200);
    } else {
      setTimeout(function () {
        const element = document.getElementById(fieldNames);
        if (element) {
          element.style.display = 'none';
        }
      }, 200);
    }
  };

  const showField = function (fieldNames) {
    if (fieldNames && Array.isArray(fieldNames)) {
      setTimeout(function () {
        fieldNames.forEach((field) => {
          const element = document.getElementById(field);
          if (element) {
            element.style.display = 'block';
          }
        });
      }, 200);
    } else {
      setTimeout(function () {
        const element = document.getElementById(fieldNames);
        if (element) {
          element.style.display = 'block';
        }
      }, 200);
    }
  };

  const refreshField = function (currentFieldName, intervalName, color, fieldName) {
    setRefreshFieldFun(currentFieldName, intervalName, color, fieldName, 'REFRESH_FIELD');
  };

  const hideTableActions = function (tableName, hideCreate, hideUpdate, hideDelete) {
    if (hideTableActionsFun) {
      hideTableActionsFun(tableName, fields, hideCreate, hideUpdate, hideDelete);
    }
  };

  const getCurrentPerspective = () => {
    const persId = perspectiveId;
    const serviceInfo = getServiceInfo();
    let currentObj = {};
    if (serviceInfo && serviceInfo.type) {
      const isPerspectiveList = bizAccountObjPermissions?.objPermissions[serviceInfo.type];
      const persObj = _.find(isPerspectiveList, { perspectiveId: persId });
      if (persObj) {
        currentObj = { name: persObj.displayLabel.toUpperCase(), id: persId };
      }
    }
    return currentObj;
  };

  const clearInterval = (fieldName) => {
    setRefreshFieldFun(null, null, null, fieldName, 'CLEAR_INTERVAL');
  };

  const setCheckboxColor = (serviceType, fiedName, choiceVal, color) => {
    const styleTag = document.createElement('style');
    styleTag.type = 'text/css';
    styleTag.innerHTML = `.checkbox_group_new #${fiedName}_${choiceVal} .checked_true {
        color: ${color} !important;
      }`

    document.head.appendChild(styleTag);

    return () => {
      document.head.removeChild(styleTag);
    };
  };

  // fields which you have to make it read only
  const readField = (fieldNames, allFields) => {
    const timeoutId = setTimeout(() => {
      if (fieldNames && Array.isArray(fieldNames)) {
        fieldNames.forEach((field) => {
          if (fields && fields[field]) {
            fields[field].isReadField = true;
          }
        });
      } else if (fields && fields[fieldNames]) {
        fields[fieldNames].isReadField = true;
      }
    }, 200);
    return () => clearTimeout(timeoutId);
  };

  // getting current txn owner data.
  const txnOwner = function () {
    var transaction = getTxnInfo();
    return transaction && transaction?.owner ? transaction?.owner : null;
  };
  // getting login user name and emil id.
  const loginUser = () => {
    const businessId = getLoginBusinessId();
    const bizAccountUserObj = getSession(`${businessId}_biz_Accocunt_user_obj`, true) || {};
    return { name: bizAccountUserObj?.name, email: bizAccountUserObj.emailId };
  };

  const updateTxn = (enableOnSubmitScript) => {
    var txnId = transaction ? transaction?.id : '';
    setTimeout(() => {
      if (txnId) {
        const isEnableOnSubmitScript = enableOnSubmitScript || false;
        if (window.updateTxnDataStateFromUtility) {
          window.updateTxnDataStateFromUtility(true, isEnableOnSubmitScript);
        }
      }
    }, 500);
  }

  const setColumnStyles = (tableName, colomnName, condition, value, styleObj, comparingColumn) => {
    // tableName, rows, 'ADD_ROW', isSink, fields[tableName]?.tableRows, fields, transaction, service?.type,perspectiveId,
    const styles = styleObj;
    const columnCheking = comparingColumn || colomnName;
    if (fields[tableName]?.tableRows && fields[tableName]?.tableRows.length > 0) {
      fields[tableName]?.tableRows?.forEach((rowObj, idx) => {
        Object.keys(rowObj.fields).forEach((key) => {
          if (key === columnCheking) {
            let conditionMet = false;
            switch (condition) {
              case "==":
                conditionMet = rowObj.fields[key].value === value;
                break;
              case "!=":
                conditionMet = rowObj.fields[key].value !== value;
                break;
              case ">":
                conditionMet = rowObj.fields[key].value > value;
                break;
              case "<":
                conditionMet = rowObj.fields[key].value < value;
                break;
              case ">=":
                conditionMet = rowObj.fields[key].value >= value;
                break;
              case "<=":
                conditionMet = rowObj.fields[key].value <= value;
                break;
              case "NONE":
                conditionMet = true;
                break;
              default:
                break;
            }
            if (conditionMet) {
              rowObj.fields[colomnName].colorVal = styles.colorVal;
              rowObj.fields[colomnName].fontSize = styles.fontSize;
              rowObj.fields[colomnName].isBold = styles.isBold;
              rowObj.fields[colomnName].backgroundColor = styles.backgroundColor;
              rowObj.fields[colomnName].borderColor = styles.borderColor;
              const element = document.querySelector(`input[name=${tableName}_${rowObj.fields[colomnName]?.refId}_${idx}]`);
              logger.debug(element);
              if (element) {
                element.style.color = styles.colorVal;
                element.style.fontSize = `${styles.fontSize}px`;
                element.style.fontWeight = styles.isBold ? 'bold' : 'normal';
                element.style.backgroundColor = styles.backgroundColor;
                element.style.borderColor = styles.borderColor;

              }
            } else {
              rowObj.fields[colomnName].colorVal = "";
              rowObj.fields[colomnName].fontSize = "13";
              rowObj.fields[colomnName].isBold = false;
              rowObj.fields[colomnName].backgroundColor = "";
              rowObj.fields[colomnName].borderColor = "";

            }
          }
        });
      });
      setTimeout(() => {
        if (window.updateStateFromUtility) window.updateStateFromUtility(fields[tableName], true);
      }, 500);
    }
  }

  const verifySubformChecks = (subformNames) => {
    var isAllSubmitted = false;
    for (const idx in subformNames) {
      var subform = subformNames[idx];
      var subFormObj = (fields) ? (fields[subform] || {}) : {};
      isAllSubmitted = subFormObj.isSubmitted;
      if (!isAllSubmitted) {
        break;
      }
    }
    return isAllSubmitted;
  }

  const applyChanges = function () {
    logger.debug("APPLY ALL CHANGES");
  }

  const externalAPI = function (method, url, headers, postData, callback) {
    $.ajax({
      type: method,
      async: false,
      url: `${url}`,
      headers,
      dataType: "json",
      data: postData !== null && JSON.stringify(postData),
      success(response) {
        if (response) {
          if (callback) callback(response);
        } else {
          showMessageAlert("Something went wrong");
        }
      }
    });
  }

  const getFileData = (fileType, fieldName, sheetName, callback) => {
    if (fileType === 'EXCEL') {

      var fileUrl = fields[fieldName] && fields[fieldName].value;

      if (fileUrl && fileUrl !== '') {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async function (resolve, reject) {
          if (fileUrl && fileUrl !== '') {
            try {
              const imgUrl = await getMediaImgSrc(fileUrl);
              const response = await fetch(imgUrl);
              const blob = await response.blob();
              const reader = new FileReader();

              reader.readAsBinaryString(blob);
              reader.onload = function (e) {
                const data = e.target.result;
                const workbook = XLSX.read(data, { type: 'binary' });
                const sheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1, raw: false }) || [];
                if (callback) callback(jsonData);
              };
              reader.onerror = function (error) {
                logger.error(error);
              };
            } catch (error) {
              logger.error(error);
            }
          }
        });
      }
    }

  }

  const decrypt = async (svcType, txnId, filedsArray, valuesArray, action, callback) => {
    try {
      const loginUserData = getLoginRes();
      const reqJson = {
        refType: svcType,
        refId: txnId,
        inputMode: action,
        fields: {}
      };

      if (filedsArray?.length > 0 && valuesArray?.length > 0) {
        filedsArray.forEach((field, index) => {
          reqJson.fields[field] = { value: valuesArray[index] };
        });
      }
      $.ajax({
        type: "POST",
        async: false,
        url: `${ApiService.baseURL}/${ApiLibrary?.V2?.DATA_DECRYPT}`,
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${loginUserData?.access_token}`,
        },
        dataType: "json",
        data: JSON.stringify(reqJson),
        success(response) {
          var res = response;
          if (res.statusCode === 0) {
            if (res.data) {
              if (callback) callback(res.data);
            } else if (callback) callback(null);
          } else {
            showWarningMessageAlert(res?.statusMessage);
          }
        }
      });
    } catch (error) {
      // Handle error here
      logger.error('An error occurred:', error);
    }
  };

  const blockSync = async (tableName, flag) => {
    logger.info('Entered into blockSync applib');
  };



  // app lib for showing spinner with text msg
  let spinnerElement = null;
  let root = null;
  const showSpinner = (msg) => {
    if (!spinnerElement) {
      spinnerElement = document.createElement('div');
      document.body.appendChild(spinnerElement);
    }
    root = createRoot(spinnerElement);
    root.render(<HooperLoadingWithText loadingMsg={msg} isShowSpinner />);
  }

  // app lib for spinner with text msg
  const hideSpinner = () => {
    if (spinnerElement) {
      // Unmount the React component
      root.unmount();
      // Remove the spinnerElement from the DOM
      document.body.removeChild(spinnerElement);
      // Clean up the spinnerElement reference
      spinnerElement = null;
    }
  }

  return {
    setServiceRelatedInfo,
    getServiceInfo,
    getTxnInfo,
    setCommentsAndAttachmentsFun,
    subFormFuns,
    setAdditionalFuns,
    setRefreshFuns,
    setHideTableActionsFun,
    tableRowsContain,
    showWarn,
    showInfo,
    showActionableAlert,
    txnId,
    fetch,
    childsOf,
    getRowsOf,
    addRows,
    updateRow,
    removeRow,
    removeRows,
    replaceRows,
    getRows,
    getRow,
    updateColumn,
    setRowsVisibile,
    commentCount,
    attachCount,
    currRefId,
    getLocation,
    mfFields,
    getTxnUsingFields,
    childsOfUsingChildType,
    findLookupTxn,
    setLookupValue,
    hideField,
    showField,
    refreshField,
    hideTableActions,
    clearInterval,
    getCurrentPerspective,
    setCheckboxColor,
    setTableCallFunFromScriptWrapper,
    rowsOf,
    getTxnUsingIncFields,
    readField,
    txnOwner,
    loginUser,
    updateTxn,
    setColumnStyles,
    verifySubformChecks,
    applyChanges,
    externalAPI,
    getFileData,
    updateAttachmentCommentsFields,
    decrypt,
    blockSync,
    showSpinner,
    hideSpinner
  };
};

export default ScriptLogicWrapperService;
